import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { PersistStorageKeys, PersistStorageService } from '../services/persist-storage.service';
import { Store } from '@ngrx/store';
import { AppState } from '../store';
import * as fromProcess from '../store/process/process.selectors';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SuccessGuard {
  isSuccess$ = this.store.select(fromProcess.selectProcessIsSuccess);

  constructor(private router: Router, private persistStorage: PersistStorageService, private store: Store<AppState>) {}

  canActivate(next: ActivatedRouteSnapshot): Observable<boolean> {
    const url = next.url.map(({ path }) => path).join('/');
    this.persistStorage.setString(PersistStorageKeys.EntryUrl, url, 'session');

    return this.isSuccess$.pipe(
      map((isSuccess) => {
        const isSuccessPage = url.includes('success');

        return isSuccessPage ? isSuccess : !isSuccess;
      }),
    );
  }
}
